import { Box, Typography } from "@mui/material";
import ConstructionIcon from "@mui/icons-material/Construction";
import { useEffect } from "react";

export default function UnderConstruction() {
    // useEffect(() => {
    //     document.body.style.overflow = "hidden"; 
    //     return () => {
    //         document.body.style.overflow = "auto"; 
    //     };
    // }, []);

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            width="100vw"
            height="100vh"
            overflow="hidden"
            position="fixed"
            top={0}
            left={0}
        >
            <ConstructionIcon color="primary" sx={{ fontSize: 200, mb: 2 }} />
            <Typography variant="h5" fontWeight="bold">
                หน้ากำลังปรับปรุง
            </Typography>
            <Typography variant="body1" color="text.secondary">
                กรุณากลับมาใหม่อีกครั้งในภายหลัง
            </Typography>
        </Box>
    );
}
